"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleServiceDeprecated = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
require('../../utilities/globalize');
var LocaleServiceDeprecated = exports.LocaleServiceDeprecated = function LocaleDeprecated($window) {
  var Globalize = $window.Globalize;
  return {
    set: function setLocale(culture) {
      Globalize.culture(culture);
    },
    get: function getLocale() {
      return Globalize.culture();
    },
    parseDate: function parseDate(text) {
      var localDate = Globalize.parseDate(text);
      if (!localDate) {
        localDate = Globalize.parseDate(text, null, 'en');
        if (!localDate) {
          localDate = Globalize.parseDate(text, 'yyyy-MM-dd');
        }
      }
      return localDate;
    },
    parseDateLocaleFormat: function parseDateLocaleFormat(text) {
      var singleDigitFormat = Globalize.culture().calendar.patterns.d.replace(/d(?=d)|M(?=M)/g, '');
      var localDate = Globalize.parseDate(text, singleDigitFormat);
      return localDate;
    },
    parseDateString: function parseDateString(value) {
      var date;
      if (typeof value === 'string') {
        if (value.indexOf('/Date(') !== -1) {
          date = new Date(parseInt(value.substr(6), 10));
        }
      }
      return date;
    },
    /**
     * Format a date object as string. Will default to Globalize's "short date" for the given culture if no formatString is specified.
     * @param date
     * @param formatString
     * @returns {string} - formatted date
     */
    formatDate: function formatDate(DATE, formatString) {
      var date = DATE,
        dateParts;
      if (typeof date === 'string') {
        if (date.indexOf('T') > 0) {
          var _date$split = date.split('T');
          var _date$split2 = _slicedToArray(_date$split, 1);
          date = _date$split2[0];
        }
        if (date.split('-').length === 3) {
          dateParts = date.split('-');
          date = new Date(dateParts[0], parseInt(dateParts[1], 10) - 1, dateParts[2]);
        }
      } else if (_momentTimezone["default"].isMoment(date)) {
        date = date.toDate();
      }
      return Globalize.format(date, formatString || 'd');
    },
    formatDateTime: function formatDateTime(DATE) {
      var date = DATE;
      if (typeof date === 'string') {
        date = new Date(Date.parse(date));
      }
      return "".concat(Globalize.format(date, 'd'), " ").concat(Globalize.format(date, 't'));
    },
    getDateFormat: function getDateFormat() {
      return Globalize.culture().calendar.patterns.d;
    },
    getLocaleMoment: function getLocaleMoment(dateInput) {
      //Use ISO
      return (0, _momentTimezone["default"])(Globalize.format(dateInput, 'yyyy-MM-dd HH:mm:ss'));
    },
    parseCurrency: function parseCurrency(text) {
      var value = Globalize.parseFloat(text);
      if (isNaN(value)) {
        return null;
      }
      return value;
    },
    formatCurrency: function formatCurrency(number, precision, culture) {
      return Globalize.format(number, "c".concat(precision || ''), culture);
    },
    formatISO: function formatISO(date) {
      return Globalize.format(date, 'yyyy-MM-dd');
    },
    formatNumber: function formatNumber(NUMBER, DECIMALS, removeTrailingZeros, padZero) {
      var number = NUMBER,
        decimalPlaces = DECIMALS,
        integerPartLength;
      if (padZero) {
        return Globalize.format(number, padZero);
      }
      if (!isNaN(number)) {
        number = Number(number);
        if (removeTrailingZeros) {
          integerPartLength = Math.floor(number).toString().length + 1;
          decimalPlaces = Math.max(0, Math.min(decimalPlaces, number.toString().length - integerPartLength));
        }
        return Globalize.format(number, "N".concat(decimalPlaces));
      } else {
        return number;
      }
    },
    formatPercentage: function formatPercentage(NUMBER, DECIMALS, removeTrailingZeros, firstDivideBy100) {
      var number = NUMBER,
        decimalPlaces = DECIMALS,
        integerPartLength;
      if (!isNaN(number)) {
        number = Number(number);
        if (removeTrailingZeros) {
          integerPartLength = Math.floor(number).toString().length + 1;
          decimalPlaces = Math.max(0, Math.min(decimalPlaces, number.toString().length - integerPartLength));
        }
        if (firstDivideBy100) {
          number /= 100;
        }
        return Globalize.format(number, "P".concat(decimalPlaces));
      } else {
        return number;
      }
    },
    getCurrencySymbol: function getCurrencySymbol() {
      return Globalize.culture().numberFormat.currency.symbol;
    }
  };
};
LocaleServiceDeprecated.$inject = ['$window'];